import { Base } from '../base-component';
import './accolades-list-simple.component.scss';

export class AccoladesListSimple extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/accolades-list-simple/accolades-list-simple.component.ts